import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MainLayout from '../layout/MainLayout';
import { LEGAL_CONTENT, LegalKey } from './legalContent';
import './LegalPage.scss';

const LegalPage: React.FC = () => {
  const { doc } = useParams<{ doc: string }>();
  const navigate = useNavigate();
  const key = (doc || '') as LegalKey;
  const content = LEGAL_CONTENT[key];

  if (!content) return <Navigate to="/contact" replace />;

  return (
    <MainLayout>
      <div className="legal-page">
        <button className="legal-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Volver
        </button>
        <div className="eyebrow">Programa de Mentoría · Mitsui</div>
        <h1>{content.title}</h1>
        <p className="legal-updated">Última actualización: {content.updated}</p>

        <div className="legal-body">
          {content.sections.map((s, i) => (
            <section key={i}>
              {s.heading && <h2>{s.heading}</h2>}
              {s.paragraphs.map((p, j) => <p key={j}>{p}</p>)}
              {s.list && (
                <ul>{s.list.map((li, k) => <li key={k}>{li}</li>)}</ul>
              )}
            </section>
          ))}
        </div>

        <p className="legal-note">
          Para consultas relacionadas con este documento, escríbenos en la{' '}
          <button className="legal-link" onClick={() => navigate('/contact')}>página de contacto</button>.
        </p>
      </div>
    </MainLayout>
  );
};

export default LegalPage;
